export function numericalCurrency(fieldValue: string) {
  // eslint-disable-next-line
  return fieldValue && !/^[\d\.\,\s]+$/.test(fieldValue)
    ? 'Must be only numbers with commas or periods'
    : undefined;
}
